import axios from 'axios'

let form = document.querySelectorAll('.js-contact-form');

form.forEach(f => {

    let formInput = f.querySelector('.js-contact-input');
    let formHeading = f.querySelector('.js-contact-heading');

    f.addEventListener('submit', e => {
        e.preventDefault();
        let formData = new FormData(f);

        axios
            .post('/', formData)
            .then(response => {
                formInput.style.display = 'none';
                formHeading.innerHTML = 'Takk for din henvendelse ';
            })

    });
});
